var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowsSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 312,
    viewBox: "0 0 319 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 312,
    rx: 24,
    fill: "#8C52FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.352 114.556C122.965 110.946 124.046 105.514 122.089 100.795C120.135 96.0758 115.53 93 110.421 93H83.6295C76.655 93 71 98.6529 71 105.627V132.417C71 137.524 74.078 142.13 78.7972 144.085C83.5165 146.04 88.9477 144.959 92.5607 141.346L97.0135 136.895L146.771 186.134L146.756 257.171C146.756 264.145 152.426 269.8 159.4 269.8C166.374 269.8 172.015 264.145 172.015 257.171L172.029 186.134L221.772 136.878L226.239 141.346C229.852 144.959 235.283 146.04 240.003 144.085C244.722 142.13 247.8 137.524 247.8 132.417V105.627C247.8 98.6529 242.145 93 235.171 93H208.379C203.27 93 198.665 96.0758 196.711 100.795C194.754 105.514 195.835 110.946 199.448 114.556L203.909 119.018L159.4 164.034L114.874 119.035L119.352 114.556Z",
    fill: "#FFE457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.396 269.8C166.37 269.8 172.01 264.145 172.01 257.171L172.025 186.134L221.767 136.878L226.235 141.346C229.848 144.959 235.279 146.04 239.998 144.085C244.718 142.13 247.796 137.524 247.796 132.417V105.627C247.796 98.6529 242.14 93 235.166 93H208.374C203.265 93 198.661 96.0758 196.706 100.795C194.75 105.514 195.83 110.946 199.443 114.556L203.905 119.018L159.396 164.034V269.8Z",
    fill: "#FFC83C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsSquare);
export default __webpack_public_path__ + "static/media/arrows-square.f5b465f814adcc72c7d07b21c2ecb726.svg";
export { ForwardRef as ReactComponent };